var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill-rule:evenodd}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people_alt-24px",
    transform: "translate(.111 .297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2275",
    transform: "translate(-.111 -.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1704",
    fill: "none",
    d: "M0 0H67V67H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2281",
    transform: "translate(2.813 11.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2276",
    transform: "translate(43.491 25.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    d: "M16.67 13.13c3.8 2.581 6.467 6.078 6.467 10.741V32.2h11.1v-8.329c.002-6.05-9.907-9.631-17.567-10.741z",
    className: "cls-2",
    transform: "translate(-16.67 -13.13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2277",
    transform: "translate(10.459 .546)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_271",
    cx: 11.5,
    cy: 10.5,
    rx: 11.5,
    ry: 10.5,
    transform: "translate(-.383 -.045)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2278",
    transform: "translate(35.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    d: "M17.361 26.2a11.1 11.1 0 0 0 0-22.2 11.6 11.6 0 0 0-3.691.666 16.6 16.6 0 0 1 0 20.871 11.6 11.6 0 0 0 3.691.663z",
    className: "cls-2",
    transform: "translate(-13.67 -4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2279",
    transform: "translate(0 24.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    d: "M23.2 13C15.793 13 1 16.719 1 24.1v8.326h44.407V24.1c0-7.381-14.793-11.1-22.207-11.1z",
    className: "cls-2",
    transform: "translate(-1 -13)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersFilled);
export default __webpack_public_path__ + "static/media/users-filled.df3238957c4e3f7e3c79f08d84e0bbaf.svg";
export { ForwardRef as ReactComponent };